// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"ee439e01","82":"3f76d975","247":"dfe61d4c","284":"284fa0b7","422":"8c711b77","440":"077281e5","627":"0c13aa45","664":"f9fa9acb","828":"769ec915","923":"bdb10d50"}[chunkId] + ".chunk.js";
};